export const state = {
    iatTask: null,
};

export const mutations = {
  FETCH_IAT_TASK_SUCCESS(state, payload) {
    state.iatTask = payload
  },
  FETCH_IAT_TASK_FAILURE(state, payload) {

  },
  ANSWER_IAT_TASK_SUCCESS(state, payload) {

  },
  ANSWER_IAT_TASK_FAILURE(state, payload) {

  }
};

